import { css } from '@emotion/react'
import {
  gemVar,
  LineWeight,
  Spacing,
  ThemedColors,
  ThemedFocusIndicator,
  Timing,
  Transition,
  Typography,
} from '@opallabs/gem'

export { panel } from '../TabsLike/styles'

const rootClassName = 'lapidary-sidebar-tabs'
export const selectors = {
  root: rootClassName,
  list: `${rootClassName}-list`,
  tab: `${rootClassName}-tab`,
  panel: `${rootClassName}-panel`,
} as const

export const list = css({
  contain: 'content',
  display: 'flex',

  // It would make more sense for this to be directly on `list` instead of a pseudo-element, but that requires a
  // negative margin-block-end on the tabs, which makes the tabs go behind `list`'s border, so the active tab's border
  // is wrong. Playing with z-index doesn't fix it.
  '&::before': {
    content: '""',
    position: 'absolute',
    insetBlockEnd: 0,
    insetInline: 0,
    borderBlockEndColor: gemVar(ThemedColors.StrokeSecondary1),
    borderBlockEndStyle: 'solid',
    borderBlockEndWidth: LineWeight.Small,
    zIndex: 1,
    ...Transition(['border-block-end-color'], {
      duration: Timing.Fastest,
    }),
  },
})

export const tab = css({
  alignItems: 'center',
  backgroundColor: 'transparent',
  blockSize: Spacing.XS * 11 - 1,
  borderWidth: 0,
  borderBlockEndColor: 'transparent',
  borderBlockEndWidth: LineWeight.Large,
  color: gemVar(ThemedColors.TextSecondary),
  contain: 'content',
  display: 'flex',
  inlineSize: 'fit-content',
  maxInlineSize: '100%',
  paddingInline: Spacing.S,
  position: 'relative',
  zIndex: 2,
  ...Transition(['background-color', 'border-color', 'color'], {
    duration: Timing.Fastest,
  }),
  ...Typography.T500,

  '&[aria-disabled=true], &:disabled': {
    opacity: 0.5,
  },
  '&:not([aria-disabled=true]):not(:disabled)': {
    cursor: 'pointer',

    '&:focus-visible': ThemedFocusIndicator,
    '&:focus-visible, &:hover': {
      color: gemVar(ThemedColors.TextPrimary),
    },
  },
  '&[data-state=active]': {
    borderBlockEndColor: gemVar(ThemedColors.StrokePrimary2),
    color: gemVar(ThemedColors.TextPrimary),
  },
})
